import debug from 'debug';
import ApiManagement from './api-management'

const log = debug('ApiManagement:Search');

class Search extends ApiManagement {

	getAutoSuggest(query, signal) {
		let url = `//${this.settings.url}/AutoSuggest?searchTerm=${query}`;
		return this.get2(url, signal);
	}

	/**
	 * Du kan lave en pipe separeret liste af guid's hvis du vil have mere end én kategori tilbage.
	 * @param {string} categoryIds 
	 * 
	 * @returns {Promise}
	 */
	getSearchReactions() {
		const url = `//${this.settings.url}/reaction`;
		// const url = `//dev-minetilbud-contentapi.azurewebsites.net/v1/reaction`;
		return this.get(url);
	}
}

export default Search;
